import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchNoticias, removeNoticia } from '../../reducers/noticia_slice';
import NoticiasForm from './NoticiasForm';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import CustomPrintModal from '../UI/CustomPrintModal';
import { useNavigate } from 'react-router-dom';

const NoticiasList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const noticias = useSelector(state => state.noticia.noticias || []);
  const [showModal, setShowModal] = useState(false);
  const [currentNoticia, setCurrentNoticia] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [printContent, setPrintContent] = useState({ head: [], body: [] });

  useEffect(() => {
    dispatch(fetchNoticias());
  }, [dispatch]);

  const handleDelete = id => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminarla!',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(removeNoticia(id)).unwrap().then(() => {
          Swal.fire('¡Eliminada!', 'La noticia ha sido eliminada.', 'success');
        }).catch(error => {
          Swal.fire('Error', error.message || 'No se pudo eliminar la noticia.', 'error');
        });
      }
    });
  };

  const handleEdit = noticia => {
    setCurrentNoticia(noticia);
    setShowModal(true);
  };

  const handleCreate = () => {
    setCurrentNoticia(null);
    setShowModal(true);
  };

  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      noticias.map(noticia => ({
        ID: noticia.id,
        "Título Corto": noticia.tituloCorto,
        "Título Largo": noticia.tituloLargo,
        "Descripción": noticia.descripcion,
        "Fecha Inicio": noticia.fechaIni,
        "Fecha Fin": noticia.fechaFin || 'Sin fecha',
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Noticias");
    XLSX.writeFile(workbook, "noticias.xlsx");
  };

  const handleShowPreview = () => {
    const content = {
      head: [['#', 'Título Corto', 'Fecha Inicio', 'Fecha Fin']],
      body: noticias.map((noticia, index) => [
        index + 1,
        noticia.tituloCorto,
        noticia.fechaIni,
        noticia.fechaFin || 'Sin fecha',
      ]),
    };
    setPrintContent(content);
    setShowPreviewModal(true);
  };

  const handleClosePreview = () => {
    setShowPreviewModal(false);
  };

  const handleBack = () => {
    navigate('/admin'); // Cambia la ruta según tu aplicación
  };

  return (
    <div className="list-container list0">
      <h1 className="table-title">Lista de Noticias</h1>
      <div className="list-container-header d-flex justify-content-between">
        <div className="left-buttons">
          <button title="Volver" onClick={handleBack} className="icon-button btn-transparent">
            <i className="bi bi-arrow-left"></i>
          </button>
        </div>
        <div className="right-buttons d-flex gap-2">
          <Button variant="outline-primary" onClick={handleCreate}>
            <i className="bi bi-plus-circle"></i> Nueva Noticia
          </Button>
          <Button variant="outline-secondary" onClick={handleShowPreview}>
            <i className="bi bi-printer"></i> Imprimir
          </Button>
          <Button variant="outline-success" onDoubleClick={handleExportExcel}>
            <i className="bi bi-file-spreadsheet"></i> Exportar a Excel
          </Button>
        </div>
      </div>
      <div className="table-container">
        <Table bordered hover size="sm">
          <thead className="text-center align-middle">
            <tr>
              <th>#</th>
              <th>Título Corto</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th> {/* Nueva columna para Fecha Fin */}
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {noticias.map((n, index) => (
              <tr key={n.id}>
                <td>{index + 1}</td> {/* Numeración basada en el índice */}
                <td>{n.tituloCorto}</td>
                <td>{n.fechaIni}</td>
                <td>{n.fechaFin || 'Sin fecha'}</td> {/* Mostrar Fecha Fin o 'Sin fecha' */}
                <td>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Editar"
                    onClick={() => handleEdit(n)}
                  >
                    <i className="bi bi-pencil"></i>
                  </Button>{' '}
                  <Button
                    variant="outline-danger"
                    size="sm"
                    title="Eliminar"
                    onClick={() => handleDelete(n.id)}
                  >
                    <i className="bi bi-trash"></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {noticias.length === 0 && (
          <p className="text-center mt-4">No hay noticias disponibles.</p>
        )}
      </div>
      <NoticiasForm currentNoticia={currentNoticia} showModal={showModal} handleClose={() => setShowModal(false)} />
      <CustomPrintModal
        show={showPreviewModal}
        handleClose={handleClosePreview}
        title1="LISTA DE NOTICIAS"
        title2=""
        content={printContent}
        copia={false}
      />
    </div>
  );
};

export default NoticiasList;
